import { Dispatch, SetStateAction, createContext } from 'react';
import { TargetStatus, Target } from '../tmp';
import { SelectedRoute, Mode } from '@/types';
import { MinimalTarget } from '@/generated/model';

export type PlutoContext = {
  selectedTargets: MinimalTarget[] | undefined;
  setSelectedTargets: Dispatch<SetStateAction<MinimalTarget[] | undefined>>;
  selectedTargetStatus: Map<number, TargetStatus>;
  setSelectedTargetStatus: Dispatch<SetStateAction<Map<number, TargetStatus>>>;
  selectedRoutes: SelectedRoute[];
  setSelectedRoutes: Dispatch<SetStateAction<SelectedRoute[]>>; // FIXME
  mode: Mode;
  setMode: Dispatch<SetStateAction<Mode>>;
  searchHistory: string[];
  setSearchHistory: Dispatch<SetStateAction<string[]>>;

  // FIXME ez legyen map
  // benne pl allapot kulon ??
  fullTargets: Target[] | undefined;
  setFullTargets: Dispatch<SetStateAction<Target[] | undefined>>;

  focusedTarget: Target | null | undefined; // Null => bekapcsolja az autoAdjust-ot
  setFocusedTarget: Dispatch<SetStateAction<Target | null | undefined>>;

  // ennek a targetnek van nyitva a popupja
  popupTargetId: number | undefined;
  setPopupTargetId: Dispatch<SetStateAction<number | undefined>>;
  immediateLoadTargetId: number | undefined;
  setImmediateLoadTargetId: Dispatch<SetStateAction<number | undefined>>;
  isBottomSheetOpen: boolean;
  setIsBottomSheetOpen: Dispatch<SetStateAction<boolean>>;

  pathLengthMinutes: number | undefined;
  setPathLengthMinutes: Dispatch<SetStateAction<number | undefined>>;
};

export const ctxPluto = createContext<PlutoContext | undefined>(undefined);
